import { Form, Message } from 'semantic-ui-react';
import PasswordRevealerInput from 'components/PasswordRevealerInput/PasswordRevealerInput';
import React, { useMemo, useState } from 'react';
import HelpText from 'components/HelpText/HelpText';
import useInput from 'hooks/useInput';

export default function RegisterForm({ loading, error, onSubmit = () => {} }) {
  const [email, setEmail] = useInput();
  const [password, setPassword] = useInput();
  const [passwordConfirm, setPasswordConfirm] = useInput();
  const [isPristine, setIsPristine] = useState(true);

  const passwordsAreEqual = useMemo(
    () => password === passwordConfirm,
    [password, passwordConfirm],
  );

  return (
    <Form onSubmit={(event, data) => onSubmit(email, password)}>
      {!isPristine && !passwordsAreEqual && (
        <Message negative style={{ marginBottom: 40 }}>
          Las contraseñas no coinciden
        </Message>
      )}
      <Form.Input
        required
        value={email}
        onChange={setEmail}
        className="email"
        label="E-mail"
      />
      <PasswordRevealerInput
        required
        value={password}
        onChange={setPassword}
        className="password"
        label="Contraseña"
        placeholder="Introduce tu contraseña"
        autoComplete="new-password"
      />
      <HelpText>
        La contraseña debe tener una longitud de 8 caracteres e incluir{' '}
        <strong>minúsculas</strong>, <strong>mayúsculas</strong> y{' '}
        <strong>caracteres especiales</strong>.
      </HelpText>
      <PasswordRevealerInput
        required
        value={passwordConfirm}
        onChange={(event, data) => {
          setPasswordConfirm(event, data);
          setIsPristine(false);
        }}
        className="password"
        label="Confirmación de contraseña"
        placeholder="Introduce de nuevo la contraseña"
        autoComplete="new-password"
      />
      <Form.Button
        className="login-button"
        primary
        fluid
        type="submit"
        disabled={!email || !password || !passwordsAreEqual || loading}
        loading={loading}
      >
        Registrar
      </Form.Button>
    </Form>
  );
}
